import { useMemo } from 'react';

const useIconEshopsWrapper = (actionLogo, withLink) => {
  const wrappedIcon = useMemo(() => {
    const IconWrapper = (children) => {
      if (withLink && actionLogo?.permalink) {
        return <a href={actionLogo.permalink}>{children}</a>;
      }

      return children;
    };

    IconWrapper.displayName = 'IconWrapper';

    return IconWrapper;
  }, [actionLogo, withLink]);

  return wrappedIcon;
};

export default useIconEshopsWrapper;
